export default __webpack_public_path__ + "static/media/bank2.7ee961b0.png";